module.exports = __webpack_public_path__ + "img/6.d3b5d4a8.jpg";